import { locationTypeEntityName, missionLocationEntityName, missionPositionEntityName, missionTypeEntityName, } from '../../../backend/config/classifiers';
import { LocationTypeAdminPage } from './components/LocationTypeAdminPage';
import { MissionLocationAdminPage } from './components/MissionLocationAdminPage';
import { MissionPositionAdminPage } from './components/MissionPositionAdminPage';
import { MissionTypeAdminPage } from './components/MissionTypeAdminPage';
const groups = {
    missions: 'Missions',
};
export const missionAdminPages = [
    {
        label: 'Location Type',
        name: locationTypeEntityName,
        path: 'locationtype',
        groupLabel: groups.missions,
        component: LocationTypeAdminPage,
    },
    {
        label: 'Mission Location',
        name: missionLocationEntityName,
        path: 'missionlocation',
        groupLabel: groups.missions,
        component: MissionLocationAdminPage,
    },
    {
        label: 'Mission Type',
        name: missionTypeEntityName,
        path: 'missiontype',
        groupLabel: groups.missions,
        component: MissionTypeAdminPage,
    },
    {
        label: 'Mission Position',
        name: missionPositionEntityName,
        path: 'missionPosition',
        groupLabel: groups.missions,
        component: MissionPositionAdminPage,
    },
];
